import camelCase from 'lodash/camelCase';

export const filterNameFormat = (
  group: string,
  filterTitle: string,
  urlDisplayName?: string
): string => `${camelCase(group)}-${urlDisplayName || camelCase(filterTitle)}`;
